import Vue from 'vue'
import { prepareFailedResponse } from 'w3box-vue-api'

export default{
  markAsRead: (id) => new Promise((resolve, reject) => {
    return Vue.http.patch(`/api/notification/${id}/read`).then(
      response => resolve(response.body),
      response => reject(prepareFailedResponse(response))
    )
  }),
  markAllRead: () => new Promise((resolve, reject) => {
    return Vue.http.patch(`/api/notification/mark-all-read`).then(
      response => resolve(response.body),
      response => reject(prepareFailedResponse(response))
    )
  }),
}
